import { usePagination } from '@hooks';

export type PendingCustomerStatus = 'PENDING' | 'APPROVED' | 'REJECTED';

export interface PendingCustomerAddress {
  city: {
    cityId?: string;
    cityName?: string;
  };
  floor: string;
  number: string;
  street: string;
  stateId: string;
  apartment: string;
  postalCode: string;
}

export interface PendingCustomerGroup {
  id: number;
  name: string;
}

export interface PendingCustomer {
  id: string;
  cuit: string;
  customerName: string;
  companyKey: string;
  customerType: string;
  customerGroup: PendingCustomerGroup | null;
  address: PendingCustomerAddress;
  status: PendingCustomerStatus;
  createdBy: string;
  createdAt: string;
  resolvedBy: string | null;
  resolvedAt: string | null;
}

export interface PendingCustomersResponse {
  page: PendingCustomer[];
  limit: number;
  offset: number;
  totalCount: number;
  totalPages: number;
  currentPage: number;
  previousPage: number | null;
  nextPage: number | null;
}

interface GetPendingCustomersParams {
  params: object;
  setURLparams: () => void;
}

/**
 * Fetches pending customer registrations paginated by status
 */
const useGetPendingCustomers = ({ params, setURLparams }: GetPendingCustomersParams) => {
  const { data: paginatedData, ...props } = usePagination('/partner/customer/pending', {
    params,
    setURLparams,
    paramKeys: ['page', 'limit', 'status'],
  });

  const data = paginatedData as PendingCustomersResponse | undefined;

  return { data, ...props };
};

export default useGetPendingCustomers;
